import { render, staticRenderFns } from "./TlmCheckoutOverview.vue?vue&type=template&id=3bb8fd07&scoped=true"
import script from "./TlmCheckoutOverview.vue?vue&type=script&lang=js"
export * from "./TlmCheckoutOverview.vue?vue&type=script&lang=js"
import style0 from "./TlmCheckoutOverview.vue?vue&type=style&index=0&id=3bb8fd07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb8fd07",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DeliveryMetaData: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/DeliveryMetaData.vue').default})
